import Script from 'next/script';

interface Props {
	brand: string;
	nonce: string;
}

export const NavigationScript = ({brand, nonce}: Props) => {
	const epicComponentDomain = process.env.EPIC_COMPONENTS_DOMAIN;

	return (
		<Script
			async
			// strategy="beforeInteractive"
			nonce={nonce}
			type="module"
			crossOrigin="anonymous"
			src={epicComponentDomain + `/navigation/${brand}-navigation.mjs`}
		/>
	);
};
